<template>

<!-- 	<table style="width:80%;margin: 0 auto; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
		<tr style="background: #EEEEEE;">
			<td style="width:90%;display: flex;justify-content: space-between;">
				<span class="qingchu">清空数据</span>
				<div style="display: flex;">
					<el-checkbox label="全选" style="margin-top: 16px;margin-right: 8px;" v-model="checkB" @change="Xuanalll"></el-checkbox>
					<div class="qingkong" @click="Del">一键清空</div>
				</div>

			</td>
		</tr>
		<tr style="background: #FFF;">
			<ul class="xuanqu">
				<li v-for="(l,i) in lie">
					<el-checkbox :label="l.name" v-model="checkA"></el-checkbox>
				</li>
			</ul>
		</tr>
	</table> -->
	<div>
	<div class="tishi">清除数据</div>
	<el-table ref="multipleTable" :data="lie" tooltip-effect="dark" style="width: 90%;margin: 0 auto;">
		<el-table-column type="selection" width="55">
		</el-table-column>
		<el-table-column label="表名" width="180">
			<template slot="header" slot-scope="scope">
			       <el-button size="small">一键清除</el-button>
			     </template>
		</el-table-column>
		<el-table-column prop="name" label="表名"  width="180">
		</el-table-column>
		<el-table-column label="描述" prop="miaoshu">
		
		</el-table-column>
	</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: 'first',
				lie: [{
						name: '1.会员数据表',
						miaoshu:'1513854868'
					},
					{
						name: '2.订单数据表',
						miaoshu:'1513854868'
					},
					{
						name: '3.余额/积分',
						miaoshu:'1513854868'
					},
					{
						name: '4.商品表',
						miaoshu:'1513854868'
					},
					{
						name: '5.分类表',
						miaoshu:'1513854868'
					},
					{
						name: '6.供应商'
					},
					{
						name: '7.派送点'
					},
					{
						name: '8.会员角色'
					},
					{
						name: '9.优惠券'
					},
					{
						name: '10.支付记录'
					},
					{
						name: '11.会员留言'
					},
					{
						name: '12.文章'
					},
					{
						name: '13.匹格商品'




					},
					{
						name: '14.匹格订单'
					},
					{
						name: '15.匹格分类'
					},
					{
						name: '16.提现记录'
					},
					{
						name: '17.登录日志'
					}
				],
				checked: true,
				checkA: [],
				checkB: false
			};
		},
		methods: {
			//实现全选
			Xuanalll() {
				var _this = this;
				this.checkA = [];
				if (this.checkB) {
					this.lie.forEach(function(item, index) {
						if (index >= 0) {
							_this.checkA.push(item.name);
						}
					});
				}
			},
			Del() {
			}
		}
	};
</script>

<style>
	.xuanqu {
		padding: 8px 0;
		/* display: flex; */
		/* flex-wrap: wrap; */
		/* justify-content: space-between; */
		margin: 0 auto;
		margin-left: 60px;
		height: 500px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		justify-content: flex-start;
	}

	.xuanqu li {
		list-style: none;
		width: 20%;
		flex: 1;
		padding: 20px 0;
	}

	.xuanqu div {
		width: 30%;
	}

	.xuanqu div li {
		margin: 20px 0;
	}

	.qingchu {
		font-size: 24px;
		line-height: 48px;
		color: #303133;
		margin-left: 20px;
	}

	.qingkong {
		width: 80px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		background: #FFFFFF;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		margin-top: 10px;
		cursor: pointer;
	}
	.tishi{font-size: 24px;color: #737373;padding-left: 80px;margin-bottom: 20px;}
</style>
